/* user/actions */
import { action } from "typesafe-actions";
import {  ResetSTANActionTypes, Data, ResetSTAN } from "./types";

export const saveRequest = (
  data: Data,
  callback?: (err: string | null, data: ResetSTAN | null) => unknown
) => action(ResetSTANActionTypes.SAVE_REQUEST, { data, callback });

export const saveSuccess = (data: ResetSTAN) =>
  action(ResetSTANActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(ResetSTANActionTypes.SAVE_ERROR, error);
